var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 3C20.2804 3 20.7891 3.21071 21.1642 3.58579C21.5393 3.96086 21.75 4.46957 21.75 5V19C21.75 19.5304 21.5393 20.0391 21.1642 20.4142C20.7891 20.7893 20.2804 21 19.75 21H5.75C5.21957 21 4.71086 20.7893 4.33579 20.4142C3.96071 20.0391 3.75 19.5304 3.75 19V5C3.75 4.46957 3.96071 3.96086 4.33579 3.58579C4.71086 3.21071 5.21957 3 5.75 3H19.75ZM19.25 18.5V13.2C19.25 12.3354 18.9065 11.5062 18.2952 10.8948C17.6838 10.2835 16.8546 9.94 15.99 9.94C15.14 9.94 14.15 10.46 13.67 11.24V10.13H10.88V18.5H13.67V13.57C13.67 12.8 14.29 12.17 15.06 12.17C15.4313 12.17 15.7874 12.3175 16.0499 12.5801C16.3125 12.8426 16.46 13.1987 16.46 13.57V18.5H19.25ZM7.63 8.56C8.07556 8.56 8.50288 8.383 8.81794 8.06794C9.133 7.75288 9.31 7.32556 9.31 6.88C9.31 5.95 8.56 5.19 7.63 5.19C7.18178 5.19 6.75193 5.36805 6.43499 5.68499C6.11805 6.00193 5.94 6.43178 5.94 6.88C5.94 7.81 6.7 8.56 7.63 8.56ZM9.02 18.5V10.13H6.25V18.5H9.02Z",
    fill: "#F2F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.62bfce3328250907ac43a9feaa774be9.svg";
export { ForwardRef as ReactComponent };